import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class LieferzeitService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

  public getLieferzeit(): Observable<string> {
    return this.http.get(this.baseUrl + '/api/lieferzeit', { responseType: 'text' });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/services/lieferzeit.service.ts